import { TLShapeId } from "@tldraw/tldraw";
import { CustomAddressBoxShape } from "pages/flyer/builder/drawer/state/newShapes/CustomAddressBoxUtil";
import { createShapesPropsFormat } from "../types";

const WIDTH = 256;
const HEIGHT = 160;
const ADDRESS_BOX_ID = "shape:addressBox" as TLShapeId;

export const shapesAddressBoxEddm: createShapesPropsFormat = (editor) => {
  const backShape = editor.getShape("shape:backBorderDashLine" as TLShapeId);
  if (!backShape) {
    return;
  }

  const addressBoxX = backShape.x + (backShape.props as any).w - WIDTH - 10;
  const addressBoxY = backShape.y + (backShape.props as any).h - HEIGHT - 10;

  const existingShape = editor.getShape(ADDRESS_BOX_ID) as CustomAddressBoxShape | null;
  const baseProps: CustomAddressBoxShape["props"] = {
    variant: "EDDM",
    w: WIDTH,
    h: HEIGHT,
    returnAddress: existingShape?.props.returnAddress ?? "{{return_address}}",
    displayReturnAddress: existingShape?.props.displayReturnAddress ?? "",
  };

  if (existingShape) {
    editor.updateShape({
      id: ADDRESS_BOX_ID,
      type: "customAddressBox",
      x: addressBoxX,
      y: addressBoxY,
      rotation: 0,
      props: {
        ...existingShape.props,
        ...baseProps,
      },
    });
    return;
  }

  editor.createShapes([
    {
      id: ADDRESS_BOX_ID,
      type: "customAddressBox",
      x: addressBoxX,
      y: addressBoxY,
      rotation: 0,
      isLocked: false,
      meta: { isAddressBox: true },
      props: baseProps,
    } as Partial<CustomAddressBoxShape> as any,
  ]);
};
